// @flow
import React from 'react';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

export function FooterSocialNetworks({ items = [] }: { items: CMSFooterSocialNetworks }) {
  if (!items.length) {
    return null;
  }

  return (
    <div className="decoration-strikethrough lg:rtl:pl-3 relative w-full lg:w-auto z-1">
      <ul className="reset-list flex md:justify-center lg:justify-start -mx-1 py-5 md:py-0">
        {items.map(({ icon, href, label }) => (
          <li className="mx-1" key={href}>
            <TrackClick
              as={DynamicLink}
              className="bg-gray-darker border-1 border-gray-dark flex items-center justify-center text-center text-white focus:text-gray-light hover:text-gray-light"
              trackingData={{
                actionGA: 'footer',
                labelGA: icon,
              }}
              target="_blank"
              url={href}
              style={{ width: '3.125rem', height: '3.125rem' }}
            >
              <Icon name={icon} width="1.5rem" alt={typeof icon === 'string' ? icon : null} />
              <span className="a11y">{`Club Med - ${label}`}</span>
            </TrackClick>
          </li>
        ))}
      </ul>
    </div>
  );
}
